import { ofType } from 'redux-observable';
import { filter, mergeMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import type { AppEpic } from 'src/store.types';
import { inputIsNotNullOrUndefined, maybeGetSubheaderComponentProps } from 'src/utils/Functions/epicsFunctions';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { clearExtraPivotParams, setExtraPivotParamsConfig, setPossibleBreadcrumbs } from './Subheader.slice';
import { fetchExtraPivotParamsOptions } from './Subheader.actions';
import { get, isEmpty } from 'lodash';
import { receiveWorklistConfig } from 'src/pages/Worklist/Worklist.slice';

export const setBreadcrumbs: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(setActivePage.type),
    map(() => {
      const breadcrumbs = get(
        state$,
        'value.perspective.activePageConf.componentProps.defns.subheader.breadcrumbs',
        null,
      );
      return breadcrumbs;
    }),
    mergeMap((possibleBreadcrumbs: string[] | null) => {
      if (isEmpty(possibleBreadcrumbs)) {
        // if we're not on a breadcrumb view, clear them out
        // SPIKE: should we only clear the current one, or all of them?
        return of(setPossibleBreadcrumbs(null));
      }
      return of(setPossibleBreadcrumbs(possibleBreadcrumbs));
    }),
  );
};

/** Used to clear out options between page loads */
export const clearExtraPivotParamsOptionsEpic: AppEpic = (action$) => {
  return action$.pipe(
    ofType(setActivePage.type, setActiveSubPage.type),
    filter(inputIsNotNullOrUndefined),
    mergeMap(() => {
      return of(clearExtraPivotParams());
    }),
  );
};

export const setExtraPivotParamsConfigEpic: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(setActivePage.type, setActiveSubPage.type, receiveWorklistConfig.type),
    map(() => maybeGetSubheaderComponentProps(state$.value)),
    filter(inputIsNotNullOrUndefined),
    mergeMap((subheaderDefns) => {
      const extraPivotParams = subheaderDefns.extraPivotParams ?? {};
      return of(setExtraPivotParamsConfig(extraPivotParams), fetchExtraPivotParamsOptions());
    }),
  );
};
